import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import { Link as MatLink } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { getLocalStorageValue } from '../../../effects/utils/local-storage';
import { navigateUser } from 'src/effects/utils/common';
import { LoginEnum } from 'src/constants/Enum/LoginEnum';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// TODO - uncomment to enable captcha
 import ReCAPTCHA from "react-google-recaptcha";
 import { VERIFY_CAPTCHA_MESSAGE } from 'src/constants/NotificationMessageConstant';

class GuestLoginComponent extends React.Component<any, any> {

    state = {
        email: '',
        password: '',
        isEmailValid: true,
        isPasswordValid: true,
        isEmailFormatValid: true,
        successMessage: '',
        isClientCaptchaVerified: false,
        showClientCaptchaNotVerifiedMessage: false
    }

    constructor(props: any) {
        super(props);

        this.getUserName = this.getUserName.bind(this);
        this.getPassword = this.getPassword.bind(this);
        this.login = this.login.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
    }

    componentDidUpdate() {
        const loggedInUser = getLocalStorageValue('user');

        if (this.props.loggedInUser && this.props.loggedInUser.success && this.props.loggedInUser.payload.roleId) {
            navigateUser(this.props.loggedInUser.payload.roleId)
        }
        else if (loggedInUser && loggedInUser.roleId) {
            if (this.props.loggedInUser.payload) {
                navigateUser(this.props.loggedInUser.payload.roleId);
            }
        }
        else if (this.props.loggedInUser && this.props.loggedInUser.error && this.props.loggedInUser.error !== null && this.state.successMessage === '') {
            this.setState({ successMessage: this.props.loggedInUser.error.messages[0] });
        }
    }

    componentDidMount() {
        this.props.clearData();
    }

    componentWillUnmount() {
        this.props.clearData();
    }


    getUserName(evt: any) {
        this.setState({ email: evt.target.value })
    }

    getPassword(evt: any) {
        this.setState({ password: evt.target.value })
    }

    validateEmail(email: any) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    validateUser() {
        let isDataValid = true;

        if (this.state.email === '') {
            this.setState({ isEmailValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isEmailValid: true });
            isDataValid = true;
        }

        if (this.state.password === '') {
            this.setState({ isPasswordValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isPasswordValid: true });
            isDataValid = true;
        }

        if (!this.validateEmail(this.state.email)) {
            this.setState({ isEmailFormatValid: false });
            isDataValid = false;
        }
        else {
            this.setState({ isEmailFormatValid: true });
            isDataValid = true;
        }

        return isDataValid;
    }

    login(evt: any) {
        /* 
         * TODO - uncomment to enable captcha
        */
        if (this.state.isClientCaptchaVerified && this.props.isCaptchaVerified) {
            if (this.validateUser()) {
                this.props.loginUser(this.state);
            }
        }
        else {
            this.setState({ showClientCaptchaNotVerifiedMessage: true });
        }
        

        // If we want to hide recaptcha code , then uncomment this code and comment above code 
        // if (this.validateUser()) {
        //     this.props.loginUser(this.state);
        // }

        evt.preventDefault()
    }

    handleForgotPassword = () => {
        this.props.handleComponentRendering(LoginEnum.ForgetPassword);
    }

    onCaptchaChange(value: any) {
        // console.log("Captcha Token:", value);        
        if (value) {
            this.setState({ showClientCaptchaNotVerifiedMessage: false });
            this.setState({ isClientCaptchaVerified: true });
            this.props.verifyCaptcha(value);
        }
        else {
            this.setState({ isClientCaptchaVerified: false });
        }
    }

    render() {
        return (
            <>
                <form className="loginForm" autoComplete="off">
                    {
                        this.state.successMessage !== '' &&
                        <FormControl margin="normal" required={true} fullWidth={true}>
                            <div className='errorMessage'>{this.state.successMessage}</div>
                        </FormControl>
                    }
                    <FormControl margin="normal" required={true} fullWidth={true}>
                        <InputLabel htmlFor="email">Email Address</InputLabel>

                        <Input id="email" name="email" autoComplete="email" autoFocus={true} onChange={this.getUserName} value={this.state.email} />
                        {!this.state.isEmailValid && <span className='errorMessage'>Email can't be empty.</span>}
                        {this.state.isEmailValid && !this.state.isEmailFormatValid && <span className='errorMessage'>Invalid Email.</span>}
                    </FormControl>
                    <FormControl margin="normal" required={true} fullWidth={true}>
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <Input name="password" type="password" id="password" autoComplete="current-password" onChange={this.getPassword} value={this.state.password} />
                        {!this.state.isPasswordValid && <span className='errorMessage'>Password can't be empty.</span>}
                    </FormControl>
                    {/*
                     *   // TODO - uncomment to disable captcha
                     *
                     *  */
                    <div className="captcha-wrapper">
                        <ReCAPTCHA
                            sitekey={this.props.appSettings && this.props.appSettings.googleCaptchaSitetKey}
                            onChange={this.onCaptchaChange}
                        />
                        {this.state.showClientCaptchaNotVerifiedMessage && <span className="errorMessage">{VERIFY_CAPTCHA_MESSAGE}</span>}
                    </div>
                   }
                    <Button
                        type="submit"
                        fullWidth={true}
                        variant="contained"
                        color="primary"
                        className="loginBtn"
                        onClick={this.login}
                    >
                        Sign In <ChevronRightIcon className="ChevronRightIcon" />
                    </Button>
                    {/* <a href="" className="forgotPassword">Forgot password ?</a> */}
                    <MatLink className="loginLink" href="javascript:void(0)" onClick={this.handleForgotPassword}>Forgot password ?</MatLink>
                    <Link to="/register">
                        <Button
                            fullWidth={true}
                            variant="contained"
                            color="primary"
                            className="registerBtn"
                        >
                            Register Here <ChevronRightIcon className="ChevronRightIcon" />
                        </Button>
                    </Link>
                </form>
            </>
        );
    }
}

export default withRouter(GuestLoginComponent);


// WEBPACK FOOTER //
// ./src/components/login/guestLogin/guestLoginComponent.tsx